<div class="upload-dialog">

    <!-- HEADER -->
    <div class="dialog-header">

        <div>
            <h2>Upload Lab Reports</h2>

            <div class="patient-info">
                {{ requisitionData?.patientName }}
                |
                Req ID : {{ requisitionData?.id }}
            </div>
        </div>

        <button mat-icon-button class="close-btn" (click)="closeDialog()">

            <mat-icon>close</mat-icon>

        </button>

    </div>

    <!-- BODY -->
    <div class="dialog-body">

        <!-- LEFT -->
        <div class="pdf-panel">

            <div class="panel-header">

                <div class="panel-title">
                    {{ previewTitle || 'Document Preview' }}
                </div>

                <button *ngIf="isViewingUploadedReport" mat-stroked-button color="primary"
                    (click)="showRequisitionPdf()">

                    Back To Requisition

                </button>

            </div>

            <div class="pdf-container">

                <!-- PDF -->

                <embed *ngIf="isPdf && documentPdfURL" [src]="documentPdfURL" type="application/pdf" class="pdf-viewer">

                <!-- IMAGE -->

                <div *ngIf="!isPdf && imageUrl" class="image-wrapper">

                    <img [src]="imageUrl" class="zoom-image">

                </div>

                <!-- EMPTY -->

                <div *ngIf="!documentPdfURL && !imageUrl" class="empty-state">

                    <mat-icon>description</mat-icon>

                    <p>No document available</p>

                </div>

            </div>

        </div>

        <!-- RIGHT -->
        <div class="report-panel">

            <!-- UPLOAD -->
            <div class="upload-card">

                <div class="panel-title">
                    Upload Reports
                </div>

                <div class="upload-box" appDnd (fileDropped)="onFileDropped($event)">

                    <input type="file" multiple #fileDropRef id="fileDropRef" accept=".pdf,.jpg,.jpeg,.png"
                        (change)="fileBrowseHandler($event.target.files)" hidden>

                    <mat-icon class="upload-icon">
                        cloud_upload
                    </mat-icon>

                    <h4>Drag & Drop Files</h4>

                    <p>
                        PDF, JPG, PNG
                    </p>

                    <button mat-raised-button color="primary" (click)="fileDropRef.click()">

                        Browse Files

                    </button>

                </div>

            </div>

            <!-- SELECTED FILES -->
            <div class="selected-files" *ngIf="fileconvertedtobase64?.length">

                <div class="panel-title">
                    Files Ready To Upload
                </div>

                <div *ngFor="let file of fileconvertedtobase64;let i=index" class="file-row">

                    <div class="file-name" (click)="viewPdf(file)">

                        <mat-icon>
                            description
                        </mat-icon>

                        {{ file.name }}

                    </div>


                    <img (click)="deleteFile(i)" style="width:30px; margin: 0px 4px; color:#007d7e; cursor: pointer;"
                        src="assets/images/delete_icon_round.svg" class="largerCheckbox" />


                </div>

            </div>

            <!-- PREVIOUS REPORTS -->
            <div class="uploaded-reports">

                <div class="panel-title">
                    Previously Uploaded Reports
                </div>

                <div *ngIf="!uploadedReportLIst?.length" class="empty-state">

                    No reports uploaded yet

                </div>

                <div *ngFor="
          let report of uploadedReportLIst" class="report-row">

                    <div style="width: 60%; word-wrap: break-word; padding: 5px 0;">

                        <div class="report-name">

                            {{ getReportFileName(report?.emailMessageIdAttchName) }}

                        </div>

                        <div class="report-date">

                            {{
                            report?.documentDate
                            | date:'dd/MM/yyyy'
                            }}

                        </div>

                    </div>

                    <div class="actions">

                        <button mat-button color="primary" (click)="onClickGetReport(report.url)">

                            View

                        </button>

                        <button mat-button color="warn" (click)="openDeletePopup(report)">

                            Delete

                        </button>


                    </div>

                </div>

            </div>

        </div>

    </div>

    <!-- FOOTER -->
    <div class="dialog-footer">

        <button mat-stroked-button (click)="closeDialog()">

            Cancel

        </button>

        <button mat-raised-button color="primary" class="upload-btn" (click)="saveChangesLabReoprt()"
            [disabled]="!fileconvertedtobase64?.length">

            <mat-icon>
                cloud_upload
            </mat-icon>

            <span>
                Upload Reports
            </span>

        </button>

    </div>

</div>




<ng-template #addDeleteModal>

    <div class="delete-popup">

        <h4>Delete Report?</h4>

        <p>
            Are you sure you want to delete this uploaded report?
        </p>

        <div class="delete-actions">

            <button mat-stroked-button (click)="closeDeleteDialog()" class="cancle-btn">

                Cancel

            </button>

            <button mat-raised-button color="warn" (click)="confirmDeleteReport()" class="delete-btn">

                Delete

            </button>

        </div>

    </div>

</ng-template>